import { Link } from 'react-router-dom'
import { DocumentMeta } from '../components/DocumentMeta'
import { PlateSearch } from '../components/PlateSearch'
import { NOT_FOUND_META } from '../domain/meta'

export function NotFoundPage() {
  return (
    <main className="container" id="main">
      <DocumentMeta {...NOT_FOUND_META} />

      <div className="state-panel">
        <h1>Deze pagina bestaat niet</h1>
        <p>
          Misschien zocht je een kentekencheck. Vul hieronder een kenteken in, of ga terug naar de{' '}
          <Link to="/">homepage</Link>.
        </p>
        <div style={{ marginTop: '2rem' }}>
          <PlateSearch autoFocus />
        </div>
      </div>
    </main>
  )
}
